<template>
    <div>
        <!-- ========== MAIN ========== -->
        <main id="content" role="main">
            <!-- Login Form -->
            <div class="container space-2">
                <form @submit="submit_form" class="js-validate w-md-75 w-lg-50 mx-md-auto">
                    <!-- Title -->
                    <div class="mb-7">
                        <h1 class="h3 text-primary font-weight-normal mb-0">Mot de passe <span class="font-weight-semi-bold">oublié?</span></h1>
                        <p>Entrer votre addresse email ci-dessous pour récupérer votre compte.</p>
                    </div>
                    <!-- End Title -->

                    <!-- Form Group -->
                    <div class="js-form-message form-group">
                        <label class="form-label" for="signinSrEmail">Addresse e-mail</label>
                        <input v-model="email" type="email" class="form-control" name="email" id="signinSrEmail" placeholder="Addresse e-mail" aria-label="Addresse e-mail" required
                               data-msg="Entrer une adresse mail valide svp."
                               data-error-class="u-has-error"
                               data-success-class="u-has-success">
                    </div>
                    <!-- End Form Group -->

                    <!-- Submit Errors -->
                    <div class="mb-7">
                        <p v-if="error" class="text-danger">{{ error }}</p>
                    </div>
                    <!-- End Submit Errors -->

                    <!-- Button -->
                    <div class="row align-items-center mb-5">
                        <div class="col-4 col-sm-6">
                            <router-link class="small link-muted"
                                         :to="{'name': 'login'}">Revenir sur la page Connexion</router-link>
                        </div>

                        <div class="col-8 col-sm-6 text-right">
                            <LoadingButton v-if="isRequestLoading"/>
                            <button v-else type="submit" class="btn btn-primary transition-3d-hover">
                                Récupérer mon compte
                            </button>
                        </div>
                    </div>
                    <!-- End Button -->
                </form>
            </div>
            <!-- End Login Form -->
        </main>
        <!-- ========== END MAIN ========== -->

        <a ref="openBasicModal" class="btn btn-sm btn-primary transition-3d-hover" href="#basicModal"
           data-modal-target="#basicModal" hidden>
            Open basic modal
        </a>
        <BasicModal :title="modal.title" :text="modal.text" :next="modal.next"/>

        <script type="application/javascript" v-bind:src="hsCoreSrc"></script>
        <script type="application/javascript" v-bind:src="hsModalWindowSrc"></script>
        <script type="application/javascript" v-bind:src="hsPluginsInitSrc"></script>
    </div>
</template>

<script>
    import {SEND_PASSWORD_RESET_MAIL} from "../../settings/graphql";
    import {JS_FILES} from "../../settings/scripts";
    import BasicModal from "../../components/BasicModal";
    import LoadingButton from "../../components/LoadingButton";
    import {errorMessageDisplay} from "../../xlib/graphql";

    export default {
        name: "RecoverAccount",
        components: {BasicModal, LoadingButton},
        data() {
            return {
                email: "",
                isRequestLoading: false,
                error: "",
                modal: {
                    text: "",
                    title: "",
                    next: ""
                },
                hsCoreSrc: JS_FILES.hs.core,
                hsModalWindowSrc: JS_FILES.hs.modalWindow,
                hsPluginsInitSrc: JS_FILES.hs.pluginsInit.modalWindow
            }
        },
        methods: {
            submit_form: function (event) {
                event.preventDefault();
                this.$data.isRequestLoading = true;
                const {email} = this.$data;

                const callbackPath = `/account/change-password`;

                this.$apollo.mutate({
                    mutation: SEND_PASSWORD_RESET_MAIL,
                    variables: {email, callbackPath}
                }).then(() => {
                    this.$data.isRequestLoading = false;
                    // console.log(result.data);
                    this.$data.modal = {
                        title: "Email envoyé",
                        text: `Nous vous avons envoyé un mail à l'adresse ${email}. Veuillez le consulter afin de
                               pouvoir mettre un nouveau mot de passe`,
                        next: 'welcome'
                    };
                    this.$refs.openBasicModal.click();
                }).catch((error) => {
                    this.$data.isRequestLoading = false;
                    // console.error(`We encountered error ${error} on favorite tags updating...`);
                    this.$data.error = errorMessageDisplay(error);
                });
            }
        }
    }
</script>

<style scoped>

</style>